import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from 'element-ui';
import { getRoleProduct, updRoleProduct } from '@/api/role';
import { listNo } from "@/api/advRelation";
export default {
  data: function data() {
    return {
      id: '',
      dialogFormVisible: false,
      productList: []
    };
  },
  created: function created() {},
  methods: {
    init: function init(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (id) {
                  _this.id = id;
                  listNo().then(function (resq) {
                    if (resq.status == 200) {
                      getRoleProduct({
                        role_id: id
                      }).then(function (res) {
                        if (res.status == 200) {
                          resq.data.map(function (i) {
                            i.Selection = res.data.findIndex(function (j) {
                              return j == i.id;
                            }) > -1 ? true : false;
                          });
                          _this.productList = resq.data;
                          _this.dialogFormVisible = true;
                        }
                      });
                    }
                  });
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataReset: function dataReset() {
      this.productList = [];
      this.dialogFormVisible = false;
      this.$emit("changeShow", false);
    },
    dataFormSubmit: function dataFormSubmit(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var list;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                list = [];

                _this2.productList.map(function (i) {
                  if (i.Selection) {
                    list.push(i.id);
                  }
                });

                updRoleProduct({
                  role_id: _this2.id,
                  product_id: list
                }).then(function (res) {
                  if (res.status == 200) {
                    Message.success('设置成功');

                    _this2.$emit('refreshDataList');

                    _this2.dataReset();
                  }
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    selectAll: function selectAll() {
      this.productList.forEach(function (item) {
        item.Selection = true;
      });
    },
    reverseSelect: function reverseSelect() {
      this.productList.forEach(function (item) {
        item.Selection = !item.Selection;
      });
    }
  }
};